// extracted by mini-css-extract-plugin
export default {"container":"SmallTutorGroupDayLesson_container__qVzx9"};